import React from 'react';

import { clearPageAlert } from 'src/services/pageAlert.service';
import styles from './pageAlert.module.scss';

export const dlsAlertId = 'dls-alert';

export default function PageAlert({ children }: { children: JSX.Element }): JSX.Element {
    return (
        <div
            className={styles.pageAlert}
            // clear if background or DLS background was clicked
            onClick={(e) => {
                if (e.currentTarget === e.target || (e.target as any).id === dlsAlertId) clearPageAlert();
            }}
        >
            {children}
        </div>
    );
}
